import * as ActionTypes from './constants';
import axios from 'axios'; 
import { baseUrl } from './';
 
 

export default function(state={}, action) {
    
    switch(action.type) {
        case ActionTypes.REQUEST_LOST_PHONE:
            return {
                ...state,
                loading: true,
                err:false,
                errInfo: null,
                status: null
            }
        case ActionTypes.RECEIVED_LOST_PHONE:
            return {
                ...state,
                loading: false,
                response: action.res,
                error: false,
                errInfo: null
            }
        case ActionTypes.ERROR_LOST_PHONE:
            return {
                ...state,
                loading: false,
                error: true,
                errInfo: action.err
            }
        case ActionTypes.CLEAR_LOST_PHONE:
            return {}
        default: return state

    }
}


const dispatchRequestLostPhone = data => ({
    type: ActionTypes.REQUEST_LOST_PHONE
})

const dispatchReceivedLostPhone= res => ({
    type: ActionTypes.RECEIVED_LOST_PHONE,
    res
})

const dispatchErrorLostPhone = err => ({
    type: ActionTypes.ERROR_LOST_PHONE,
    err
})

const dispatchClearLostPhone = () => ({
    type: ActionTypes.CLEAR_LOST_PHONE
})

export const clearLostPhone = () => dispatchClearLostPhone();

export const lostPhone = email => dispatch => {

    dispatch(dispatchRequestLostPhone(email)); 
            const options = {
                method: 'post',
                url: `${baseUrl}/api/lostphone`,
                data:{
                    email
                }
            }
             axios(options)
                .then(({data}) => {                
                    dispatch(dispatchReceivedLostPhone(data))
                })
               .catch(e => dispatch(dispatchErrorLostPhone(e)));   
}
